export enum COMPANY_LEVEL_DIALOGS {
    InfoPanel = "infoPanel",
    Basic = "Basic",
    Standard = "Standard",
    Premium = "Premium"
}
